export default "__VITE_ASSET__CH3q9_va__"